import { isApiError } from "@pokifolio/api-client";

/** Turns any error into one sentence a person can act on, plus the reference id for support. */
export function describeError(error: unknown): { message: string; reference: string | undefined } {
  if (isApiError(error)) {
    return { message: error.detail ?? error.title, reference: error.requestId };
  }
  return { message: "Something went wrong. Please try again.", reference: undefined };
}

/** The server's message for one form field, if it rejected that field. */
export function serverFieldError(error: unknown, path: string): string | undefined {
  return isApiError(error) ? error.fieldError(path) : undefined;
}
